import script from "./tabIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./tabIndex.vue?vue&type=script&setup=true&lang=js"

import "./tabIndex.vue?vue&type=style&index=0&id=17e0d2e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e0d2e8"]])

export default __exports__